export default __webpack_public_path__ + "static/media/imageLogisticsContentThree.3283a738.png";